var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":"ReimbursementTab"}},[_c(_vm.currentComponent,{tag:"component",attrs:{"isFinance":_vm.isFinance,"ID":_vm.ID},on:{"toggle":_vm.toggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }